/**
 * Kurs-Buchung – Terminauswahl auf Kurs-/Event-Produktseiten
 * -----------------------------------------------------------
 * Liest die per Liquid injizierten Termine (event.termine) aus dem Config-Script,
 * filtert vergangene raus, rendert eine Radio-Liste, einen Plätze-Stepper und
 * hängt den gewählten Termin als Line-Item-Properties ans Produktformular.
 *
 * Properties:
 *   Termin       – sichtbar, z.B. "Di 15. Juli · 18:00 Uhr"
 *   _termin_id   – versteckt (intern, für Verfügbarkeitsprüfung Phase 3)
 *
 * Phase 2: freie Plätze = plaetze_gesamt. Phase 3 zieht echte Buchungen ab.
 */
(function () {
  'use strict';

  var WOCHENTAGE = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
  var MONATE = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli',
                'August', 'September', 'Oktober', 'November', 'Dezember'];
  var MONATE_KURZ = ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez.'];

  function parseDate(d) {
    var p = String(d).split('-');
    return new Date(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10));
  }

  function formatTermin(datum, uhrzeit) {
    var dt = parseDate(datum);
    return WOCHENTAGE[dt.getDay()] + ' ' + dt.getDate() + '. ' + MONATE[dt.getMonth()] +
           ' · ' + (uhrzeit || '') + ' Uhr';
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function dauerLabel(min) {
    var m = parseInt(min, 10);
    if (isNaN(m)) return '';
    if (m < 60) return m + ' Min';
    var h = m / 60;
    return (h === Math.floor(h) ? String(h) : String(h).replace('.', ',')) + ' Std';
  }

  // Lange Variante MIT Jahr + Dauer, nur für die Listenansicht.
  // Produktseite nutzt weiterhin formatTermin (ohne Jahr).
  function formatTerminLang(datum, uhrzeit, dauerMin) {
    var dt = parseDate(datum);
    var s = WOCHENTAGE[dt.getDay()] + ' ' + dt.getDate() + '. ' + MONATE[dt.getMonth()] +
            ' ' + dt.getFullYear() + ' · ' + (uhrzeit || '') + ' Uhr';
    var d = dauerLabel(dauerMin);
    if (d) s += ' (' + d + ')';
    return s;
  }

  // ── Warteliste (Phase 7) ────────────────────────────────────────────────
  // Klick auf einen ausgebuchten Termin klappt ein Formular darunter auf.
  // Beide Modi (Varianten wie Worker-Fallback) benutzen dieselbe Funktion.
  function wartelisteAktiv(cfg) {
    return !!(cfg && cfg.warteliste && cfg.warteliste.aktiv);
  }

  function wartelisteToggle(cfg, t, optEl) {
    var vorhanden = optEl.nextElementSibling;
    if (vorhanden && vorhanden.classList.contains('kurs-booking__wl')) {
      vorhanden.remove();
      return;
    }
    var box = wartelisteFormular(cfg, t);
    optEl.insertAdjacentElement('afterend', box);
    // Die Terminliste scrollt (max-height) — sonst landet das Formular außerhalb
    // des sichtbaren Bereichs und wirkt, als wäre nichts passiert.
    if (box.scrollIntoView) box.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  function wartelisteFormular(cfg, t) {
    var box = document.createElement('div');
    box.className = 'kurs-booking__wl';

    var text = document.createElement('p');
    text.className = 'kurs-booking__wl-text';
    text.textContent = 'Dieser Termin ist ausgebucht. Trag dich ein — wird ein Platz frei, ' +
      'bekommst du ihn als Erste angeboten, der Reihe nach.';
    box.appendChild(text);

    var row = document.createElement('div');
    row.className = 'kurs-booking__wl-row';

    var name = document.createElement('input');
    name.type = 'text';
    name.className = 'kurs-booking__wl-input';
    name.placeholder = 'Dein Name';
    name.autocomplete = 'name';

    var mail = document.createElement('input');
    mail.type = 'email';
    mail.className = 'kurs-booking__wl-input';
    mail.placeholder = 'E-Mail-Adresse';
    mail.autocomplete = 'email';
    mail.required = true;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kurs-booking__wl-submit';
    btn.textContent = 'Auf die Warteliste';

    row.appendChild(name);
    row.appendChild(mail);
    row.appendChild(btn);
    box.appendChild(row);

    var msg = document.createElement('p');
    msg.className = 'kurs-booking__wl-msg';
    msg.hidden = true;
    box.appendChild(msg);

    var klein = document.createElement('p');
    klein.className = 'kurs-booking__wl-klein';
    klein.textContent = 'Wir speichern deine Angaben nur für diesen Termin und melden uns ' +
      'ausschließlich dazu. Du kannst dich jederzeit über den Link in der E-Mail wieder austragen.';
    box.appendChild(klein);

    function zeige(txt, ok) {
      msg.hidden = false;
      msg.textContent = txt;
      msg.className = 'kurs-booking__wl-msg kurs-booking__wl-msg--' + (ok ? 'ok' : 'err');
    }

    btn.addEventListener('click', function () {
      var base = (cfg.workerUrl || '').replace(/\/$/, '');
      if (!base) { zeige('Die Warteliste ist gerade nicht erreichbar.', false); return; }
      if (!mail.value || mail.value.indexOf('@') < 0) { zeige('Bitte gib deine E-Mail-Adresse an.', false); return; }
      btn.disabled = true;
      btn.textContent = 'Wird eingetragen …';
      fetch(base + '/warteliste', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          produktId: cfg.produktId,
          terminId: t.id,
          email: mail.value.trim(),
          name: name.value.trim(),
          plaetze: 1
        })
      })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (res.ok && res.body && res.body.ok) {
            row.hidden = true;
            zeige(res.body.bereits
              ? 'Du stehst bereits auf der Warteliste — wir haben deine Angaben aktualisiert.'
              : 'Eingetragen! Wir melden uns per E-Mail, sobald ein Platz frei wird. ' +
                'Die Plätze vergeben wir der Reihe nach.', true);
          } else {
            zeige((res.body && res.body.error) || 'Das hat leider nicht geklappt.', false);
            btn.disabled = false;
            btn.textContent = 'Auf die Warteliste';
          }
        })
        .catch(function () {
          zeige('Netzwerkfehler — bitte versuch es gleich noch einmal.', false);
          btn.disabled = false;
          btn.textContent = 'Auf die Warteliste';
        });
    });

    return box;
  }


  // ── Theme-Anbindung ────────────────────────────────────────────────────────
  // Lianne (Be Yours) reicht die Formular-ID mit. Als Theme-App-Block (Kunden-
  // shops, z. B. Antonio mit „Local") kennt der Block sie nicht — dann das
  // Kaufformular der eigenen Section suchen: das mit dem Warenkorb-Knopf.
  function findeFormular(root, formId) {
    if (formId) { var f = document.getElementById(formId); if (f) return f; }
    var eigen = root.closest('form');
    if (eigen) return eigen;
    for (var el = root.parentElement; el; el = el.parentElement) {
      var forms = el.querySelectorAll('form[action$="/cart/add"]');
      for (var i = 0; i < forms.length; i++) {
        if (forms[i].querySelector('[name="add"], .product-form__submit')) return forms[i];
      }
    }
    return null;
  }

  // Knopf beschriften, ohne innere Elemente (Lade-Animation in „Local") zu zerstören
  function knopfText(btn, text) {
    var lbl = btn.querySelector('[data-js-product-add-to-cart-text], .button__text');
    (lbl || btn).textContent = text;
  }

  // Theme-eigene Mengenauswahl, Variantenwahl und Express-Checkout ausblenden.
  // Express-Knöpfe (PayPal, Shop Pay) würden Terminwahl und AGB-Häkchen umgehen.
  function versteckeThemeTeile(root, form, qtyInput) {
    var weg = function (el) { if (el) el.style.setProperty('display', 'none', 'important'); };
    if (form) {
      weg(form.querySelector('.product-form__quantity'));
      if (qtyInput && qtyInput.type !== 'hidden') weg(qtyInput.closest('product-quantity, .product-quantity, quantity-input, .quantity'));
      var pay = form.querySelectorAll('.shopify-payment-button, shopify-accelerated-checkout');
      for (var i = 0; i < pay.length; i++) weg(pay[i]);
    }
    var sektion = root.closest('.shopify-section') || document;
    var varianten = sektion.querySelectorAll('product-variants[data-main-product-variants]');
    for (var j = 0; j < varianten.length; j++) weg(varianten[j]);
  }

  function init(root) {
    var cfgEl = root.querySelector('[data-kurs-config]');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { cfg = {}; }
    var termine = (cfg && Array.isArray(cfg.termine)) ? cfg.termine : [];

    var listEl = root.querySelector('[data-kurs-list]');
    var emptyEl = root.querySelector('[data-kurs-empty]');
    var qtyWrap = root.querySelector('[data-kurs-qty]');
    var qtyMinus = root.querySelector('[data-qty-minus]');
    var qtyPlus = root.querySelector('[data-qty-plus]');
    var qtyValue = root.querySelector('[data-qty-value]');
    var agbCheckbox = root.querySelector('[data-kurs-agb]');

    // Produktformular + Steuerelemente finden
    var formId = root.getAttribute('data-form-id');
    var form = findeFormular(root, formId);
    var submitBtn = form ? form.querySelector('.product-form__submit, button[name="add"]') : null;

    // Quantity-Input sicherstellen (manche Blocks rendern keins)
    var qtyInput = null;
    if (form) {
      qtyInput = form.querySelector('input[name="quantity"]');
      if (!qtyInput && formId) qtyInput = document.querySelector('input[name="quantity"][form="' + formId + '"]');
      if (!qtyInput) {
        qtyInput = document.createElement('input');
        qtyInput.type = 'hidden';
        qtyInput.name = 'quantity';
        qtyInput.value = '1';
        form.appendChild(qtyInput);
      }
      // Theme-Mengenauswahl, Varianten und Express-Checkout aus (eigener Stepper)
      versteckeThemeTeile(root, form, qtyInput);
    }

    // Sticky-Cart defensiv ausblenden (für kurse-Template bereits serverseitig aus)
    var sticky = document.querySelector('.sticky-cart-wrapper, .product-sticky-cart');
    if (sticky) sticky.style.display = 'none';

    var selectedTermin = null;
    var agbOk = agbCheckbox ? agbCheckbox.checked : true;

    // Button für Kurse immer als "Jetzt buchen" labeln; aktiv nur wenn Termin + AGB ok
    if (submitBtn) knopfText(submitBtn, (cfg && cfg.knopfText) || 'Jetzt buchen →');

    function updateSubmit() {
      if (!submitBtn) return;
      var ready = !!selectedTermin && agbOk;
      submitBtn.disabled = !ready;
      submitBtn.classList.toggle('kurs-disabled', !ready);
    }

    if (agbCheckbox) {
      agbCheckbox.addEventListener('change', function () {
        agbOk = agbCheckbox.checked;
        updateSubmit();
      });
    }

    // ── Live-Verfügbarkeitscheck beim Submit (H3) ─────────────────────────
    // Zwischen Seitenaufruf und Klick können andere den Termin wegbuchen
    // (Cache bis 60 s alt). Submit in der Capture-Phase auf Dokument-Ebene
    // abfangen (läuft vor Shopifys product-form-Handler), live prüfen, dann
    // erneut submitten. Worker nicht erreichbar → durchlassen (wie bisher).
    var atcPassed = false;

    function atcError(msg) {
      var el = root.querySelector('.kurs-booking__atc-error');
      if (!el) {
        el = document.createElement('p');
        el.className = 'kurs-booking__atc-error';
        el.style.cssText = 'margin:10px 0 0;padding:10px 14px;background:#faf0ee;border:1px solid #d9a79c;border-radius:8px;font-size:14px;color:#a14a3a;';
        root.appendChild(el);
      }
      el.textContent = msg;
    }
    function clearAtcError() {
      var el = root.querySelector('.kurs-booking__atc-error');
      if (el) el.remove();
    }

    function fetchFrei(t) {
      var base = (cfg.workerUrl || '').replace(/\/$/, '');
      if (!base || !cfg.produktId || !t.id) return Promise.resolve(null);
      var gesamt = parseInt(t.plaetze_gesamt, 10) || 0;
      var url = base + '/verfuegbarkeit?termin_id=' + encodeURIComponent(t.id) +
                '&produkt_id=' + encodeURIComponent(cfg.produktId) + '&gesamt=' + gesamt;
      // Zeitlimit 4 s: Hängt der Worker (z. B. Cloudflare-Störung am 13.09.2026),
      // darf die Buchung nicht am Live-Check hängen bleiben — Shopify prüft das
      // Inventar ohnehin beim Checkout (Überbuchung wird dort geblockt).
      var ctrl = (typeof AbortController === 'function') ? new AbortController() : null;
      var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 4000) : null;
      return fetch(url, ctrl ? { signal: ctrl.signal } : undefined)
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (d) { return (typeof d.frei === 'number') ? d.frei : null; })
        .catch(function () { return null; })
        .then(function (v) { if (timer) clearTimeout(timer); return v; });
    }

    if (form) {
      document.addEventListener('submit', function (ev) {
        if (ev.target !== form || !selectedTermin) return;
        if (atcPassed) { atcPassed = false; return; }
        ev.preventDefault();
        ev.stopImmediatePropagation();
        var t = selectedTermin;
        var menge = parseInt(qtyInput && qtyInput.value, 10) || 1;
        if (submitBtn) submitBtn.disabled = true;
        fetchFrei(t).then(function (frei) {
          if (submitBtn) submitBtn.disabled = false;
          if (frei == null || frei >= menge) {
            clearAtcError();
            atcPassed = true;
            if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
            return;
          }
          // Zu wenig Plätze → blocken, Anzeige korrigieren
          t.frei = frei;
          if (frei <= 0) {
            var wlJetzt = wartelisteAktiv(cfg);
            atcError('Dieser Termin ist leider inzwischen ausgebucht.' +
              (wlJetzt ? ' Du kannst dich auf die Warteliste setzen.' : ''));
            if (t._el) {
              t._el.classList.add('is-full');
              t._el.classList.remove('is-selected');
              // Datum stehen lassen, nur den Platz-Hinweis umschreiben
              var s = t._el.querySelector('.kurs-booking__seats');
              if (s) s.innerHTML = '<span class="kurs-booking__seats--full">' +
                (wlJetzt ? 'ausgebucht · Warteliste' : 'ausgebucht') + '</span>';
              if (wlJetzt) {
                t._el.classList.add('has-warteliste');
                t._el.insertAdjacentElement('afterend', wartelisteFormular(cfg, t));
              } else {
                t._el.disabled = true;
              }
            }
            selectedTermin = null;
            qtyWrap.hidden = true;
            updateSubmit();
          } else {
            atcError('Es ' + (frei === 1 ? 'ist nur noch 1 Platz' : 'sind nur noch ' + frei + ' Plätze') + ' frei — bitte Anzahl anpassen.');
            currentMax = frei;
            setQty(frei);
            if (t._el) {
              var se = t._el.querySelector('.kurs-booking__seats');
              if (se) se.textContent = frei + (frei === 1 ? ' Platz frei' : ' Plätze frei');
            }
          }
        });
      }, true);
    }

    function ensureProp(name) {
      if (!form) return null;
      var el = form.querySelector('input[data-kurs-prop="' + name + '"]');
      if (!el) {
        el = document.createElement('input');
        el.type = 'hidden';
        el.name = 'properties[' + name + ']';
        el.setAttribute('data-kurs-prop', name);
        form.appendChild(el);
      }
      return el;
    }

    var currentMax = 1;

    function setQty(v) {
      v = Math.min(currentMax, Math.max(1, v));
      qtyValue.textContent = v;
      if (qtyInput) {
        qtyInput.value = v;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (qtyMinus) qtyMinus.addEventListener('click', function () {
      setQty((parseInt(qtyValue.textContent, 10) || 1) - 1);
    });
    if (qtyPlus) qtyPlus.addEventListener('click', function () {
      setQty((parseInt(qtyValue.textContent, 10) || 1) + 1);
    });

    function selectTermin(t, optEl) {
      clearAtcError();
      var options = listEl.querySelectorAll('.kurs-booking__option');
      for (var i = 0; i < options.length; i++) options[i].classList.remove('is-selected');
      optEl.classList.add('is-selected');

      var label = formatTermin(t.datum, t.uhrzeit);
      var pTermin = ensureProp('Termin');
      if (pTermin) pTermin.value = label;
      var pId = ensureProp('_termin_id');
      if (pId) pId.value = t.id || '';
      // Für die Buchungsverwaltung im Kundenkonto (Phase 6b): Produkt-ID +
      // ISO-Datum als versteckte Properties, damit die Customer-Account-Extension
      // den Storno (produktId + terminId) auslösen und kommend/vergangen
      // unterscheiden kann.
      var pProd = ensureProp('_produkt_id');
      if (pProd) pProd.value = cfg.produktId != null ? String(cfg.produktId) : '';
      var pDatum = ensureProp('_termin_datum');
      if (pDatum) pDatum.value = t.datum || '';
      // Unix-Timestamp (Sekunden) des Termins — ermöglicht Klaviyo, die
      // Erinnerungs-Mail exakt 48 h vorher zu triggern. datum (YYYY-MM-DD) +
      // uhrzeit (HH:MM) werden als lokale Zeit interpretiert; für das
      // deutsche Publikum = Termin-Zeitzone (Europe/Berlin).
      var pTs = ensureProp('_termin_timestamp');
      if (pTs) {
        var dp = String(t.datum || '').split('-');
        var tp = String(t.uhrzeit || '00:00').split(':');
        if (dp.length === 3) {
          var ms = new Date(
            parseInt(dp[0], 10), parseInt(dp[1], 10) - 1, parseInt(dp[2], 10),
            parseInt(tp[0], 10) || 0, parseInt(tp[1], 10) || 0, 0
          ).getTime();
          pTs.value = isNaN(ms) ? '' : String(Math.floor(ms / 1000));
        } else {
          pTs.value = '';
        }
      }
      // Mitbringsel: als versteckte Property (für Klaviyo-Erinnerungs-Mail als
      // dynamischer Block) + dezenter Hinweis unter dem gewählten Termin.
      var pMit = ensureProp('_mitbringsel');
      if (pMit) pMit.value = t.mitbringsel || '';
      var oldHints = listEl.querySelectorAll('.kurs-booking__hint');
      for (var h = 0; h < oldHints.length; h++) oldHints[h].remove();
      var hint;
      if (t.mitbringsel) {
        hint = document.createElement('p');
        hint.className = 'kurs-booking__hint';
        hint.textContent = 'Mitbringen: ' + t.mitbringsel;
        optEl.insertAdjacentElement('afterend', hint);
      }
      if (t.ort) {
        var ortHint = document.createElement('p');
        ortHint.className = 'kurs-booking__hint kurs-booking__hint--ort';
        ortHint.textContent = 'Ort: ' + t.ort;
        (hint || optEl).insertAdjacentElement('afterend', ortHint);
      }

      currentMax = Math.max(1, parseInt(t.frei, 10) || 1);
      qtyWrap.hidden = false;
      setQty(1);

      selectedTermin = t;
      updateSubmit();
    }

    // Vergangene Termine ausblenden, aufsteigend sortieren
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var future = termine
      .filter(function (t) { return t && t.datum && !t.abgesagt && parseDate(t.datum) >= today; })
      .sort(function (a, b) { return parseDate(a.datum) - parseDate(b.datum); });

    if (!future.length) {
      if (emptyEl) emptyEl.hidden = false;
      updateSubmit();
      return;
    }

    // Verfügbarkeit per Worker prüfen, dann rendern. Button bleibt bis dahin aus.
    var loadingEl = document.createElement('p');
    loadingEl.className = 'kurs-booking__empty';
    loadingEl.textContent = 'Verfügbarkeit wird geprüft …';
    listEl.appendChild(loadingEl);
    updateSubmit();

    loadAvailability(future).then(function (resolved) {
      loadingEl.remove();
      renderOptions(resolved);
    });

    function renderOptions(list) {
      list.forEach(function (t) {
        var frei = parseInt(t.frei, 10);
        if (isNaN(frei)) frei = 0;
        var full = frei <= 0;

        var wl = full && wartelisteAktiv(cfg);
        var opt = document.createElement('button');
        opt.type = 'button';
        opt.className = 'kurs-booking__option' + (full ? ' is-full' : '') + (wl ? ' has-warteliste' : '');
        // Das Datum bleibt auch bei ausgebuchten Terminen stehen — sonst weiß
        // niemand, für welchen Termin er sich auf die Warteliste setzt.
        var seats = full
          ? '<span class="kurs-booking__seats--full">' + (wl ? 'ausgebucht · Warteliste' : 'ausgebucht') + '</span>'
          : (frei + (frei === 1 ? ' Platz frei' : ' Plätze frei'));
        opt.innerHTML =
          '<span class="kurs-booking__radio"></span>' +
          '<span class="kurs-booking__date">' + escapeHtml(formatTermin(t.datum, t.uhrzeit)) + '</span>' +
          '<span class="kurs-booking__seats">' + seats + '</span>';

        t._el = opt; // Rückreferenz für Live-Korrekturen beim ATC-Check
        if (full && !wl) {
          opt.disabled = true;
        } else if (full) {
          opt.addEventListener('click', function () { wartelisteToggle(cfg, t, opt); });
        } else {
          opt.addEventListener('click', function () { selectTermin(t, opt); });
        }
        listEl.appendChild(opt);
      });
    }

    // Ruft pro Termin den Worker auf (parallel). Bei Fehler/Nichterreichbarkeit:
    // Fallback auf statisches plaetze_gesamt.
    function loadAvailability(items) {
      var base = (cfg.workerUrl || '').replace(/\/$/, '');
      var produktId = cfg.produktId;
      function staticFrei(t) {
        var g = parseInt(t.plaetze_gesamt, 10);
        return Object.assign({}, t, { frei: isNaN(g) ? 0 : g });
      }
      if (!base || !produktId) {
        return Promise.resolve(items.map(staticFrei));
      }
      return Promise.all(items.map(function (t) {
        var gesamt = parseInt(t.plaetze_gesamt, 10);
        if (isNaN(gesamt)) gesamt = 0;
        var url = base + '/verfuegbarkeit?termin_id=' + encodeURIComponent(t.id) +
                  '&produkt_id=' + encodeURIComponent(produktId) + '&gesamt=' + gesamt;
        return fetch(url)
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
          .then(function (d) {
            return Object.assign({}, t, { frei: (typeof d.frei === 'number') ? d.frei : gesamt });
          })
          .catch(function () { return staticFrei(t); });
      }));
    }
  }

  // ── Varianten-Modus (Variante-pro-Termin-Umbau) ─────────────────────────
  // Termine sind Shopify-Varianten: Restplätze kommen serverseitig aus dem
  // Inventar (im Config-JSON), die Auswahl setzt nur die Variant-ID im
  // nativen Produktformular. Kein Worker-Call, kein Submit-Hijacking —
  // Überbuchung verhindert Shopify selbst (Policy deny).
  function initVariants(root) {
    var cfgEl = root.querySelector('[data-kurs-config]');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { cfg = {}; }
    var termine = (cfg && Array.isArray(cfg.termine)) ? cfg.termine : [];

    var listEl = root.querySelector('[data-kurs-list]');
    var emptyEl = root.querySelector('[data-kurs-empty]');
    var qtyWrap = root.querySelector('[data-kurs-qty]');
    var qtyMinus = root.querySelector('[data-qty-minus]');
    var qtyPlus = root.querySelector('[data-qty-plus]');
    var qtyValue = root.querySelector('[data-qty-value]');
    var agbCheckbox = root.querySelector('[data-kurs-agb]');

    var formId = root.getAttribute('data-form-id');
    var form = findeFormular(root, formId);
    var submitBtn = form ? form.querySelector('.product-form__submit, button[name="add"]') : null;
    var idInput = form ? form.querySelector('input[name="id"]') : null;

    var qtyInput = null;
    if (form) {
      qtyInput = form.querySelector('input[name="quantity"]');
      if (!qtyInput && formId) qtyInput = document.querySelector('input[name="quantity"][form="' + formId + '"]');
      if (!qtyInput) {
        qtyInput = document.createElement('input');
        qtyInput.type = 'hidden';
        qtyInput.name = 'quantity';
        qtyInput.value = '1';
        form.appendChild(qtyInput);
      }
      // Theme-Mengenauswahl, Varianten und Express-Checkout aus (eigener Stepper)
      versteckeThemeTeile(root, form, qtyInput);
    }
    var sticky = document.querySelector('.sticky-cart-wrapper, .product-sticky-cart');
    if (sticky) sticky.style.display = 'none';

    var selectedTermin = null;
    var agbOk = agbCheckbox ? agbCheckbox.checked : true;
    if (submitBtn) knopfText(submitBtn, (cfg && cfg.knopfText) || 'Jetzt buchen →');

    function updateSubmit() {
      if (!submitBtn) return;
      var ready = !!selectedTermin && agbOk;
      submitBtn.disabled = !ready;
      submitBtn.classList.toggle('kurs-disabled', !ready);
    }
    if (agbCheckbox) {
      agbCheckbox.addEventListener('change', function () {
        agbOk = agbCheckbox.checked;
        updateSubmit();
      });
    }

    function ensureProp(name) {
      if (!form) return null;
      var el = form.querySelector('input[data-kurs-prop="' + name + '"]');
      if (!el) {
        el = document.createElement('input');
        el.type = 'hidden';
        el.name = 'properties[' + name + ']';
        el.setAttribute('data-kurs-prop', name);
        form.appendChild(el);
      }
      return el;
    }

    var currentMax = 1;
    function setQty(v) {
      v = Math.min(currentMax, Math.max(1, v));
      qtyValue.textContent = v;
      if (qtyInput) {
        qtyInput.value = v;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    if (qtyMinus) qtyMinus.addEventListener('click', function () {
      setQty((parseInt(qtyValue.textContent, 10) || 1) - 1);
    });
    if (qtyPlus) qtyPlus.addEventListener('click', function () {
      setQty((parseInt(qtyValue.textContent, 10) || 1) + 1);
    });

    // Vergangene raus, aufsteigend sortieren
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var future = termine
      .filter(function (t) { return t && t.datum && !t.abgesagt && parseDate(t.datum) >= today; })
      .sort(function (a, b) { return parseDate(a.datum) - parseDate(b.datum); });

    if (!future.length) {
      if (emptyEl) emptyEl.hidden = false;
      updateSubmit();
      return;
    }

    // Preise nur anzeigen, wenn sie sich zwischen Terminen unterscheiden
    var preise = {};
    future.forEach(function (t) { preise[t.preis] = true; });
    var zeigePreis = Object.keys(preise).length > 1;

    function selectTermin(t, optEl) {
      var options = listEl.querySelectorAll('.kurs-booking__option');
      for (var i = 0; i < options.length; i++) options[i].classList.remove('is-selected');
      optEl.classList.add('is-selected');

      // Native Variantenauswahl: ID setzen + aktivieren (Input ist initial disabled)
      if (idInput) {
        idInput.value = t.variantId;
        idInput.removeAttribute('disabled');
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Versteckte Properties für Worker-Scans, Klaviyo & Kundenkonto.
      // Kein sichtbares "Termin"-Property mehr — der Variantentitel übernimmt das.
      var pId = ensureProp('_termin_id');
      if (pId) pId.value = t.id || '';
      var pProd = ensureProp('_produkt_id');
      if (pProd) pProd.value = cfg.produktId != null ? String(cfg.produktId) : '';
      var pDatum = ensureProp('_termin_datum');
      if (pDatum) pDatum.value = t.datum || '';
      var pTs = ensureProp('_termin_timestamp');
      if (pTs) {
        var dp = String(t.datum || '').split('-');
        var tp = String(t.uhrzeit || '00:00').split(':');
        var ms = dp.length === 3 ? new Date(
          parseInt(dp[0], 10), parseInt(dp[1], 10) - 1, parseInt(dp[2], 10),
          parseInt(tp[0], 10) || 0, parseInt(tp[1], 10) || 0, 0
        ).getTime() : NaN;
        pTs.value = isNaN(ms) ? '' : String(Math.floor(ms / 1000));
      }
      var pMit = ensureProp('_mitbringsel');
      if (pMit) pMit.value = t.mitbringsel || '';

      // Mitbringsel-Hinweis unter dem gewählten Termin
      var oldHints = listEl.querySelectorAll('.kurs-booking__hint');
      for (var h = 0; h < oldHints.length; h++) oldHints[h].remove();
      var hint;
      if (t.mitbringsel) {
        hint = document.createElement('p');
        hint.className = 'kurs-booking__hint';
        hint.textContent = 'Mitbringen: ' + t.mitbringsel;
        optEl.insertAdjacentElement('afterend', hint);
      }
      if (t.ort) {
        var ortHint = document.createElement('p');
        ortHint.className = 'kurs-booking__hint kurs-booking__hint--ort';
        ortHint.textContent = 'Ort: ' + t.ort;
        (hint || optEl).insertAdjacentElement('afterend', ortHint);
      }

      currentMax = Math.max(1, parseInt(t.frei, 10) || 1);
      qtyWrap.hidden = false;
      setQty(1);
      selectedTermin = t;
      updateSubmit();
    }

    future.forEach(function (t) {
      var frei = parseInt(t.frei, 10);
      if (isNaN(frei)) frei = 0;
      var full = frei <= 0;
      var wl = full && wartelisteAktiv(cfg);
      var opt = document.createElement('button');
      opt.type = 'button';
      opt.className = 'kurs-booking__option' + (full ? ' is-full' : '') + (wl ? ' has-warteliste' : '');
      var seats = full
        ? '<span class="kurs-booking__seats--full">' + (wl ? 'ausgebucht · Warteliste' : 'ausgebucht') + '</span>'
        : (frei + (frei === 1 ? ' Platz frei' : ' Plätze frei'));
      if (!full && zeigePreis && t.preis) seats = escapeHtml(t.preis) + ' · ' + seats;
      opt.innerHTML =
        '<span class="kurs-booking__radio"></span>' +
        '<span class="kurs-booking__date">' + escapeHtml(formatTermin(t.datum, t.uhrzeit)) + '</span>' +
        '<span class="kurs-booking__seats">' + seats + '</span>';
      if (full && !wl) {
        opt.disabled = true;
      } else if (full) {
        opt.addEventListener('click', function () { wartelisteToggle(cfg, t, opt); });
      } else {
        opt.addEventListener('click', function () { selectTermin(t, opt); });
      }
      listEl.appendChild(opt);
    });
    updateSubmit();
  }

  // ── Listenansicht (Phase 5, Neugestaltung 2026-09-12) ───────────────────
  // Zwei Darstellungen, umschaltbar über die Sektionseinstellung „layout":
  //   kalender  – ein Eintrag pro Termin, chronologisch, mit Monatsmarken;
  //               Datumsblock links, Titel und Uhrzeit, Preis, Status. Kein Bild.
  //   programm  – ein Eintrag pro Kurs mit Bild und Kurztext, die kommenden
  //               Termine als Liste darin, sortiert nach dem nächsten Termin.
  // Beide: Grün nur am Link, Knappheit nur wenn echt (ausgebucht / wenige).
  var ORT_STANDARD = /steinweg/i; // der Laden – wird nicht extra genannt

  function formatTerminKurz(datum, uhrzeit) {
    var dt = parseDate(datum);
    var jahr = dt.getFullYear() !== new Date().getFullYear() ? ' ' + dt.getFullYear() : '';
    return WOCHENTAGE[dt.getDay()] + ', ' + dt.getDate() + '. ' + MONATE_KURZ[dt.getMonth()] + jahr +
           (uhrzeit ? ' · ' + uhrzeit + ' Uhr' : '');
  }
  function ortKurz(ort) { return String(ort || '').split(',')[0].trim(); }
  function preisZahl(s) {
    var n = parseFloat(String(s || '').replace(/[^\d,\.]/g, '').replace(',', '.'));
    return isNaN(n) ? Infinity : n;
  }
  // Gegenwert für das Preis-Badge: Gutschein (event.gutschein_wert) + Kurztext
  // (event.inklusive), z. B. „10 € Gutschein + Getränk von Silvio". Leer = kein Zusatz.
  function gegenwert(p) {
    var teile = [];
    var gw = parseFloat(p.gutschein);
    if (gw > 0) teile.push(String(gw).replace('.', ',') + ' € Gutschein*');
    if (p.inklusive) teile.push(String(p.inklusive).trim());
    return teile.filter(Boolean).join(' + ');
  }
  // Primär-Tags → Anzeigename (Reihenfolge fest, damit „Event & Stricktreff" stabil bleibt)
  var TYP_LABEL = [['kurs', 'Kurs'], ['event', 'Event'], ['stricktreff', 'Stricktreff']];
  function primaerTypen(tagsCsv) {
    var tags = String(tagsCsv || '').split(',').map(function (t) { return t.trim().toLowerCase(); });
    return TYP_LABEL.filter(function (x) { return tags.indexOf(x[0]) > -1; }).map(function (x) { return x[1]; });
  }

  // "ausgebucht" | "wenige" | "" — und null, wenn noch unbekannt
  function knappheit(frei, gesamt) {
    if (frei == null || isNaN(frei)) return null;
    if (frei <= 0) return 'ausgebucht';
    var g = parseInt(gesamt, 10);
    if (frei <= 3 || (g > 0 && frei / g <= 0.25)) return 'wenige';
    return '';
  }
  function flagHtml(frei, gesamt, cls) {
    var k = knappheit(frei, gesamt);
    if (k === 'ausgebucht') return '<span class="' + cls + '">ausgebucht</span>';
    if (k === 'wenige') return '<span class="' + cls + ' ' + cls + '--few">nur noch ' + frei + (frei === 1 ? ' Platz' : ' Plätze') + '</span>';
    return '';
  }

  // Daten aus dem Sektions-JSON: pro Produkt die kommenden Termine mit Preis
  // und freien Plätzen aus der Variante (unmigrierte Termine: frei = null).
  function sammleEintraege(cfg, today) {
    var eintraege = [];
    ((cfg && Array.isArray(cfg.produkte)) ? cfg.produkte : []).forEach(function (p) {
      var raw = p.termine;
      if (typeof raw === 'string') { try { raw = JSON.parse(raw); } catch (e) { raw = []; } }
      if (!Array.isArray(raw)) raw = [];
      var varianten = Array.isArray(p.varianten) ? p.varianten : [];
      var termine = raw
        .filter(function (t) { return t && t.datum && !t.abgesagt && parseDate(t.datum) >= today; })
        .map(function (t) {
          var variante = null;
          if (t.variant_id) {
            var vid = parseInt(String(t.variant_id).split('/').pop(), 10);
            for (var i = 0; i < varianten.length; i++) if (varianten[i].id === vid) { variante = varianten[i]; break; }
          }
          return { id: t.id, datum: t.datum, uhrzeit: t.uhrzeit || '', dauer_minuten: t.dauer_minuten,
                   plaetze_gesamt: t.plaetze_gesamt, ort: t.ort || '',
                   preis: variante ? variante.preis : p.preis,
                   frei: variante ? variante.frei : null };
        })
        .sort(function (a, b) {
          var d = parseDate(a.datum) - parseDate(b.datum);
          return d !== 0 ? d : String(a.uhrzeit).localeCompare(String(b.uhrzeit));
        });
      if (termine.length) eintraege.push({ p: p, termine: termine });
    });
    eintraege.sort(function (a, b) {
      var d = parseDate(a.termine[0].datum) - parseDate(b.termine[0].datum);
      return d !== 0 ? d : String(a.termine[0].uhrzeit).localeCompare(String(b.termine[0].uhrzeit));
    });
    return eintraege;
  }

  // Unmigrierte Termine: freie Plätze vom Worker nachladen und Status setzen
  function ladeFreiNach(base, p, t, el, flagCls, fullCls) {
    if (t.frei != null || !base || !p.produktId || !t.id || !el) return;
    var gesamt = parseInt(t.plaetze_gesamt, 10) || 0;
    var url = base + '/verfuegbarkeit?termin_id=' + encodeURIComponent(t.id) +
              '&produkt_id=' + encodeURIComponent(p.produktId) + '&gesamt=' + gesamt;
    fetch(url)
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (d) {
        var frei = (typeof d.frei === 'number') ? d.frei : gesamt;
        var flag = el.querySelector('[data-kurs-flag]');
        if (flag) flag.innerHTML = flagHtml(frei, gesamt, flagCls);
        if (knappheit(frei, gesamt) === 'ausgebucht') el.classList.add(fullCls);
      })
      .catch(function () {});
  }

  // ── Kalender: ein Eintrag pro Termin, Monatsmarken dazwischen ────────────
  function renderKalender(container, eintraege, base) {
    var flat = [];
    eintraege.forEach(function (e) {
      e.termine.forEach(function (t) { flat.push({ p: e.p, t: t }); });
    });
    flat.sort(function (a, b) {
      var d = parseDate(a.t.datum) - parseDate(b.t.datum);
      return d !== 0 ? d : String(a.t.uhrzeit).localeCompare(String(b.t.uhrzeit));
    });
    var jetzt = new Date();
    var letzterMonat = '';
    flat.forEach(function (x) {
      var p = x.p, t = x.t;
      var dt = parseDate(t.datum);
      var monatKey = dt.getFullYear() + '-' + dt.getMonth();
      if (monatKey !== letzterMonat) {
        letzterMonat = monatKey;
        var m = document.createElement('p');
        m.className = 'kurs-kalender__monat';
        m.textContent = MONATE[dt.getMonth()] + (dt.getFullYear() !== jetzt.getFullYear() ? ' ' + dt.getFullYear() : '');
        container.appendChild(m);
      }
      var k = knappheit(t.frei, t.plaetze_gesamt);
      var row = document.createElement('a');
      row.className = 'kurs-kalender__row' + (k === 'ausgebucht' ? ' kurs-kalender__row--full' : '');
      row.href = p.url || '#';
      var dauer = dauerLabel(t.dauer_minuten);
      var ort = (t.ort && !ORT_STANDARD.test(t.ort)) ? ortKurz(t.ort) : '';
      var zeit = [t.uhrzeit ? t.uhrzeit + ' Uhr' : '', dauer, ort].filter(Boolean).join(' · ');
      var inkl = gegenwert(p);
      row.innerHTML =
        '<span class="kurs-kalender__datum">' +
          '<span class="kurs-kalender__wt">' + WOCHENTAGE[dt.getDay()] + '</span>' +
          '<span class="kurs-kalender__tag">' + dt.getDate() + '</span>' +
          '<span class="kurs-kalender__mon">' + MONATE_KURZ[dt.getMonth()] + '</span>' +
        '</span>' +
        '<span class="kurs-kalender__body">' +
          '<span class="kurs-kalender__titel">' + escapeHtml(p.titel || '') + '</span>' +
          (zeit ? '<span class="kurs-kalender__zeit">' + escapeHtml(zeit) + '</span>' : '') +
          (inkl ? '<span class="kurs-kalender__inkl">inkl. ' + escapeHtml(inkl) + '</span>' : '') +
        '</span>' +
        '<span class="kurs-kalender__preis">' + escapeHtml(t.preis || '') + '</span>' +
        '<span class="kurs-kalender__status" data-kurs-flag>' + flagHtml(t.frei, t.plaetze_gesamt, 'kurs-kalender__flag') + '</span>' +
        '<span class="kurs-kalender__link">' +
          (k === 'ausgebucht' ? (x.p.warteliste ? 'Warteliste' : '') : 'Buchen') + '</span>';
      container.appendChild(row);
      ladeFreiNach(base, p, t, row, 'kurs-kalender__flag', 'kurs-kalender__row--full');
    });
  }

  // ── Programm: ein Eintrag pro Kurs mit Bild ──────────────────────────────
  function renderProgramm(container, eintraege, base) {
    eintraege.forEach(function (e) {
      var p = e.p, termine = e.termine;
      var row = document.createElement('a');
      row.className = 'kurs-programm__row' + (p.bild ? '' : ' kurs-programm__row--noimage');
      row.href = p.url || '#';
      // Rahmen im Seitenverhältnis des Produktfotos → kein Beschnitt (Fallback 1:1)
      var ratio = parseFloat(p.bildRatio);
      if (!(ratio > 0.3 && ratio < 4)) ratio = 1;
      var media = p.bild
        ? '<div class="kurs-programm__media" style="aspect-ratio:' + ratio + '"><img src="' + escapeHtml(p.bildKlein || p.bild) + '"' +
          ' srcset="' + escapeHtml(p.bildKlein || p.bild) + ' 480w, ' + escapeHtml(p.bild) + ' 900w"' +
          ' sizes="(max-width: 749px) 100vw, 38vw" alt="' + escapeHtml(p.bildAlt || '') + '" loading="lazy"></div>'
        : '';
      var dates = termine.map(function (t) {
        var dauer = dauerLabel(t.dauer_minuten);
        var ort = (t.ort && !ORT_STANDARD.test(t.ort)) ? ortKurz(t.ort) : '';
        var meta = [dauer, ort].filter(Boolean).join(' · ');
        var k = knappheit(t.frei, t.plaetze_gesamt);
        return '<li class="kurs-programm__date' + (k === 'ausgebucht' ? ' kurs-programm__date--full' : '') + '"' +
               ' data-kurs-date="' + escapeHtml(String(t.id)) + '">' +
               '<span class="kurs-programm__date-main">' + escapeHtml(formatTerminKurz(t.datum, t.uhrzeit)) + '</span>' +
               (meta ? '<span class="kurs-programm__date-meta">' + escapeHtml(meta) + '</span>' : '') +
               '<span data-kurs-flag>' + flagHtml(t.frei, t.plaetze_gesamt, 'kurs-programm__flag') + '</span>' +
               '</li>';
      }).join('');
      var preise = {};
      termine.forEach(function (t) { if (t.preis) preise[t.preis] = preisZahl(t.preis); });
      var keys = Object.keys(preise);
      var preisText = keys.length === 1 ? keys[0]
        : (keys.length > 1 ? 'ab ' + keys.sort(function (a, b) { return preise[a] - preise[b]; })[0] : '');
      // Preis-Badge mit Gegenwert: „10,00 € · inkl. 10 € Gutschein + Getränk von Silvio"
      var inkl = gegenwert(p);
      var preisBadge = preisText
        ? '<p class="kurs-programm__preis"><strong>' + escapeHtml(preisText) + '</strong>' +
          (inkl ? '<span class="kurs-programm__preis-inkl">· inkl. ' + escapeHtml(inkl) + '</span>' : '') + '</p>'
        : '';
      // Badges: Typ (bei zwei Primär-Tags „Event & Stricktreff", damit das doppelte
      // Erscheinen in beiden Filtern nicht wie ein Fehler wirkt) + Level
      var typen = primaerTypen(p.tags);
      var badges = [];
      if (typen.length) badges.push('<span class="kurs-programm__badge kurs-programm__badge--typ">' + typen.map(escapeHtml).join(' &amp; ') + '</span>');
      if (p.level) badges.push('<span class="kurs-programm__badge">' + escapeHtml(p.level) + '</span>');
      var badgesHtml = badges.length ? '<p class="kurs-programm__badges">' + badges.join('') + '</p>' : '';
      row.innerHTML = media +
        '<div class="kurs-programm__body">' +
          badgesHtml +
          '<h3 class="kurs-programm__title">' + escapeHtml(p.titel || '') + '</h3>' +
          (p.kurz ? '<p class="kurs-programm__text">' + escapeHtml(p.kurz) + '</p>' : '') +
          '<ul class="kurs-programm__dates">' + dates + '</ul>' +
          preisBadge +
          '<span class="kurs-programm__link">Details und Buchung</span>' +
        '</div>';
      container.appendChild(row);
      termine.forEach(function (t) {
        ladeFreiNach(base, p, t, row.querySelector('[data-kurs-date="' + t.id + '"]'), 'kurs-programm__flag', 'kurs-programm__date--full');
      });
    });
  }

  function ladeVerfuegbarkeitFuerListe() {
    var container = document.querySelector('[data-kurs-liste]');
    if (!container) return;
    var cfgEl = document.querySelector('[data-kurs-liste-config]');
    var cfg = {};
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { cfg = {}; }
    var emptyEl = container.querySelector('[data-kurs-liste-empty]');
    var base = (cfg.workerUrl || '').replace(/\/$/, '');
    var today = new Date();
    today.setHours(0, 0, 0, 0);

    var eintraege = sammleEintraege(cfg, today);
    if (!eintraege.length) { if (emptyEl) emptyEl.hidden = false; return; }

    var layout = container.getAttribute('data-kurs-layout') || 'kalender';
    if (layout === 'programm') renderProgramm(container, eintraege, base);
    else renderKalender(container, eintraege, base);
  }

  // ── Erlebnisse-Filter ohne Seitenwechsel ─────────────────────────────────
  // Die Filterlinks sind echte URLs (/collections/erlebnisse/kurs …). Beim Klick
  // holen wir nur den Listen-Abschnitt vom Server (?section_id=…), tauschen ihn
  // aus, rendern die Liste neu und setzen die URL per History-API. Scrollposition
  // bleibt, Header springt nicht nach oben. Ohne JS oder bei Fehlern: normaler
  // Seitenwechsel. Back/Forward laden denselben Weg.
  function initErlebnisseFilter() {
    var nav = document.querySelector('[data-erlebnisse-filter]');
    if (!nav || !window.fetch || !window.history || !history.pushState) return;
    var sectionId = nav.getAttribute('data-erlebnisse-filter');
    var wrap = document.getElementById('shopify-section-' + sectionId);
    if (!wrap) return;

    function lade(url, push) {
      var sep = url.indexOf('?') > -1 ? '&' : '?';
      wrap.setAttribute('aria-busy', 'true');
      wrap.style.opacity = '0.55';
      return fetch(url + sep + 'section_id=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var neu = doc.getElementById('shopify-section-' + sectionId) || doc.body;
          wrap.innerHTML = neu.innerHTML;
          wrap.style.opacity = '';
          wrap.removeAttribute('aria-busy');
          if (push) history.pushState({ erlebnisse: url }, '', url);
          ladeVerfuegbarkeitFuerListe();
          bind();
          // Liste sichtbar halten, falls die Filterleiste oberhalb des Viewports liegt
          var n = wrap.querySelector('[data-erlebnisse-filter]');
          if (n && n.getBoundingClientRect().top < 0) n.scrollIntoView({ block: 'start', behavior: 'smooth' });
        });
    }

    function bind() {
      var n = wrap.querySelector('[data-erlebnisse-filter]');
      if (!n) return;
      n.addEventListener('click', function (ev) {
        var a = ev.target.closest('a[href]');
        if (!a || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.button !== 0) return;
        ev.preventDefault();
        var url = a.getAttribute('href');
        lade(url, true).catch(function () { location.assign(url); });
      });
    }
    bind();
    history.replaceState({ erlebnisse: location.pathname }, '', location.href);
    window.addEventListener('popstate', function (ev) {
      if (ev.state && ev.state.erlebnisse) lade(ev.state.erlebnisse, false).catch(function () { location.reload(); });
    });
  }

  // Klaviyo „Benachrichtige mich" (Back in Stock) auf Kurs-/Event-Seiten ausblenden.
  // Für Kurse haben wir die eigene Warteliste: Sie reserviert den Platz exklusiv,
  // während Klaviyo nur alle gleichzeitig anschreibt. Zwei Knöpfe nebeneinander
  // verwirren. Der Knopf wird von Klaviyo verzögert nachgeladen — deshalb mehrfach
  // nachfassen (gleiche Technik wie in strickset-handler.js).
  function versteckeKlaviyoBis() {
    function weg() {
      var treffer = document.querySelectorAll(
        '#klaviyo-bis-button-container, [class*="klaviyo-bis"], [class*="kl-private-reset-css"]');
      for (var i = 0; i < treffer.length; i++) {
        var el = treffer[i];
        var txt = (el.textContent || '');
        if (el.id === 'klaviyo-bis-button-container' ||
            txt.indexOf('BENACHRICHTIGE') !== -1 || txt.indexOf('Benachrichtige') !== -1 ||
            txt.indexOf('Notify') !== -1) {
          el.style.setProperty('display', 'none', 'important');
        }
      }
    }
    weg();
    setTimeout(weg, 500);
    setTimeout(weg, 2000);
    setTimeout(weg, 5000);
  }

  function boot() {
    var roots = document.querySelectorAll('[data-kurs-booking]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
    var vroots = document.querySelectorAll('[data-kurs-variants]');
    for (var j = 0; j < vroots.length; j++) initVariants(vroots[j]);
    if (roots.length || vroots.length) versteckeKlaviyoBis();
    ladeVerfuegbarkeitFuerListe();
    initErlebnisseFilter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
